/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Workspace_Aside_DetailsInputs */

const en_directory_submit_workspace_aside_details = /** @type {(inputs: Directory_Submit_Workspace_Aside_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Confirm website`)
};

const zh_directory_submit_workspace_aside_details = /** @type {(inputs: Directory_Submit_Workspace_Aside_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`确认网站`)
};

/**
* | output |
* | --- |
* | "Confirm website" |
*
* @param {Directory_Submit_Workspace_Aside_DetailsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_workspace_aside_details = /** @type {((inputs?: Directory_Submit_Workspace_Aside_DetailsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Workspace_Aside_DetailsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_workspace_aside_details(inputs)
	return zh_directory_submit_workspace_aside_details(inputs)
});
export { directory_submit_workspace_aside_details as "directory.submit.workspace.aside.details" }